<template>
  <div class="home">
    <UomList v-show="listView" @newUom="onClickNewFromList" @editUom="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <UomForm v-show="formView" :uom="uom" :idUom="idUom" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import UomList from '@/components/uom/UomList.vue'
import UomForm from '@/components/uom/UomForm.vue'

export default {
  name: 'Uom',
  components: {
    UomList,
    UomForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      idUom: null,
      uom: {
        id: null,
        name: null,
        category_id: null,
        type_id: null,
        ratio: null,
        active: null,
        category: null,
        type: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(value)
      this.listView = false
      this.formView = true
      this.uom = value
      this.idUom = value.id
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.idUom = null
      this.uom = {
        id: null,
        name: null,
        category_id: null,
        type_id: null,
        ratio: 0,
        active: null,
        category: null,
        type: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.uom = {
        id: null,
        name: null,
        category_id: null,
        type_id: null,
        ratio: null,
        active: null,
        category: null,
        type: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getUomCategoryList')
    this.$store.dispatch('getUomTypeList')
    this.$store.dispatch('getRowTable')
  }
}
</script>
